<!--  -->
<template>
  <div>
    <div>
      <el-tabs value="first" @tab-click="handleClickChange">
        <el-tab-pane label="消息列表" name="first">
          <div class="header-select">
            <el-form inline>
              <el-form-item label="公众号选择：">
                <el-select clearable v-model="AppId" @change="handleChangeGetList">
                  <el-option
                    v-for="item in AppIdsOptions"
                    :key="item.value"
                    :label="item.app_name"
                    :value="item.app_id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="exportMessage">导出消息</el-button>
              </el-form-item>
            </el-form>
          </div>
          <!-- 消息列表 -->
          <div v-if="messageList.length > 0" v-loading="listLoading">
            <div class="content" v-for="(item, index) in messageList" :key="item.msg_id">
              <div class="message-list">
                <div class="head-portrait" @click="handleUserDetail(item)">
                  <el-avatar shape="square" :size="48" :src="item.user.user_img || avatarDefault" />
                </div>
                <div class="message-data">
                  <div>
                    <span style="max-width: 80%">
                      {{ item.user.nick_name || item.open_id || '-' }}
                    </span>
                    <span v-if="item.is_reply === 1" class="reply-tag">已回复</span>
                  </div>
                  <div v-if="item.msg_type === 1">{{ item.msg_content || '-' }}</div>
                  <div v-if="item.msg_type === 2" @click="handleDetailImg(item)">
                    <img width="100px" height="140px" :src="item.media_url" alt="" />
                  </div>
                  <div
                    v-if="item.msg_type === 3"
                    @click="handleDetailVideo(item)"
                    style="position: relative"
                  >
                    <video height="100px" width="160px" :src="item.media_url"></video>
                    <div
                      class="el-icon-video-play"
                      style="
                        position: absolute;
                        font-size: 40px;
                        width: 40px;
                        height: 40px;
                        color: #f3f3f3;
                        top: 35px;
                        left: 59px;
                      "
                    ></div>
                  </div>
                  <div v-if="item.msg_type === 4">
                    <Maudio block ref="audio" :src="item.media_url" showduration></Maudio>
                  </div>
                  <div v-if="item.msg_type === 5">
                    <el-link
                      target="_blank"
                      :href="item.msg_content"
                      type="primary"
                      :underline="false"
                    >
                      {{ item.msg_content }}
                    </el-link>
                  </div>
                  <div v-if="item.msg_type === 6">
                    <!-- <p>所处地址：{{ Object.values(JSON.parse(item.msg_content))[0] }}</p>
                    <p>经度坐标：{{ Object.values(JSON.parse(item.msg_content))[1] }}</p>
                    <p>维度坐标：{{ Object.values(JSON.parse(item.msg_content))[2] }}</p> -->
                    <Maps :items="item" :index="index"></Maps>
                  </div>
                  <div v-if="item.msg_type === -1">【收到不支持的消息类型，暂无法显示】</div>
                  <div>{{ item.create_time | parseTime }}</div>
                </div>
                <div>{{ item.doctor.doctor_name || '' }}</div>
                <div>{{ item.doctor.hospital || '' }}</div>
                <div>{{ item.doctor.department || '' }}</div>
                <div>
                  <p v-for="(val, i) in item.user.tag" :key="i">
                    {{ val }}
                  </p>
                </div>
                <div>{{ item.app_name }}</div>
                <!-- <div>{{ item.doctor.representative_name || '' }}</div> -->
                <div>
                  <el-button
                    style="padding: 0px"
                    type="text"
                    :disabled="!item.doctor.representative_id"
                    @click="handleJumpBehalf(item.doctor.representative_id)"
                  >
                    {{ item.doctor.representative_name || '' }}
                  </el-button>
                </div>
                <div>
                  <img
                    @click="handleCollect(item)"
                    v-if="item.is_collect === 1"
                    :src="collect"
                    alt=""
                  />
                  <img
                    @click="handleCollect(item)"
                    v-if="item.is_collect === 2"
                    :src="noCollect"
                    alt=""
                  />
                  <span class="el-icon-chat-line-square" @click="handleShowInput(item)"></span>
                </div>
              </div>
              <!-- 输入框 -->
              <el-collapse-transition>
                <div v-if="item.inputShow">
                  <div class="send-content">
                    <el-input
                      type="textarea"
                      maxlength="600"
                      show-word-limit
                      v-model="content"
                    ></el-input>
                  </div>
                  <div class="send-button">
                    <el-button @click="handlePackUp(item)">收起</el-button>
                    <el-button type="primary" @click="sendMessage(item)">发送</el-button>
                  </div>
                </div>
              </el-collapse-transition>
            </div>
          </div>
          <!-- 无消息时展示 -->
          <div class="no-news" v-else v-loading="loading">暂无内容</div>
          <!-- 分页 -->
          <div style="margin-top: 20px; float: right" v-if="messageList.length > 0">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page_index"
              :page-size="page_size"
              :page-sizes="g_pageSizesConfig"
              layout="total,sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
          <!-- 视频放大 -->
          <el-dialog :visible.sync="msgVideoDialogVisible" width="50%" @close="handleClose">
            <div style="display: flex; justify-content: center; align-items: center">
              <Mvideo width="800" height="400" name="1" :src="msgVideoSrc"></Mvideo>
            </div>
          </el-dialog>
          <!-- 图片放大 -->
          <el-dialog :visible.sync="msgImgDialogVisible" class="img-dialog" width="30%">
            <div style="display: flex; justify-content: center; align-items: center">
              <img width="100%" height="auto" :src="msgImgSrc" />
            </div>
          </el-dialog>
        </el-tab-pane>

        <el-tab-pane label="收藏消息" name="second">
          <div class="header-select">
            <el-form inline>
              <el-form-item label="公众号选择：">
                <el-select clearable v-model="collectAppId" @change="handleChangeCollectGetList">
                  <el-option
                    v-for="item in AppIdsOptions"
                    :key="item.value"
                    :label="item.app_name"
                    :value="item.app_id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <!-- 消息列表 -->
          <div v-if="collectMessageList.length > 0" v-loading="collectListLoading">
            <div class="content" v-for="(item, index) in collectMessageList" :key="item.msg_id">
              <div class="message-list">
                <div class="head-portrait" @click="handleUserDetail(item)">
                  <el-avatar shape="square" :size="48" :src="item.user.user_img || avatarDefault" />
                </div>
                <div class="message-data">
                  <div>
                    <span
                      style="
                        max-width: 80%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                      "
                      :title="item.user.nick_name || item.open_id || '-'"
                    >
                      {{ item.user.nick_name || item.open_id || '-' }}
                    </span>
                    <span v-if="item.is_reply === 1" class="reply-tag">已回复</span>
                  </div>
                  <div v-if="item.msg_type === 1">{{ item.msg_content }}</div>
                  <div v-if="item.msg_type === 2" @click="handleDetailCollectImg(item)">
                    <img width="100px" height="140px" :src="item.media_url" alt="" />
                  </div>
                  <div
                    v-if="item.msg_type === 3"
                    @click="handleDetailCollectVideo(item)"
                    style="position: relative"
                  >
                    <video height="100px" width="160px" :src="item.media_url"></video>
                    <div
                      class="el-icon-video-play"
                      style="
                        position: absolute;
                        font-size: 40px;
                        width: 40px;
                        height: 40px;
                        color: #f3f3f3;
                        top: 35px;
                        left: 59px;
                      "
                    ></div>
                  </div>
                  <div v-if="item.msg_type === 4">
                    <Maudio block ref="audio" :src="item.media_url" showduration></Maudio>
                  </div>
                  <div v-if="item.msg_type === 5">
                    <el-link
                      target="_blank"
                      :href="item.msg_content"
                      type="primary"
                      :underline="false"
                    >
                      {{ item.msg_content }}
                    </el-link>
                  </div>
                  <div v-if="item.msg_type === 6">
                    <!-- <p>所处地址：{{ Object.values(JSON.parse(item.msg_content))[0] }}</p>
                    <p>经度坐标：{{ Object.values(JSON.parse(item.msg_content))[1] }}</p>
                    <p>维度坐标：{{ Object.values(JSON.parse(item.msg_content))[2] }}</p> -->
                    <Maps :items="item" :index="index - 0 + 1000"></Maps>
                  </div>
                  <div v-if="item.msg_type === -1">【收到不支持的消息类型，暂无法显示】</div>
                  <div>{{ item.create_time | parseTime }}</div>
                </div>
                <div>{{ item.doctor.doctor_name || '' }}</div>
                <div>{{ item.doctor.hospital || '' }}</div>
                <div>{{ item.doctor.department || '' }}</div>
                <div>
                  <p v-for="(val, i) in item.user.tag" :key="i">
                    {{ val }}
                  </p>
                </div>
                <div>{{ item.app_name }}</div>
                <div>
                  <el-button
                    style="padding: 0px"
                    type="text"
                    @click="handleJumpBehalf(item.doctor.representative_id)"
                  >
                    {{ item.doctor.representative_name || '' }}
                  </el-button>
                </div>
                <div>
                  <img
                    @click="handleCollect(item)"
                    v-if="item.is_collect === 1"
                    :src="collect"
                    alt=""
                  />
                  <img
                    @click="handleCollect(item)"
                    v-if="item.is_collect === 2"
                    :src="noCollect"
                    alt=""
                  />
                  <span class="el-icon-chat-line-square" @click="handleShowInput(item)"></span>
                </div>
              </div>
              <!-- 输入框 -->
              <el-collapse-transition>
                <div v-if="item.inputShow">
                  <div class="send-content">
                    <el-input
                      type="textarea"
                      maxlength="600"
                      show-word-limit
                      v-model="collectContent"
                    ></el-input>
                  </div>
                  <div class="send-button">
                    <el-button @click="handlePackUp(item)">收起</el-button>
                    <el-button type="primary" @click="sendMessage(item)">发送</el-button>
                  </div>
                </div>
              </el-collapse-transition>
            </div>
          </div>
          <!-- 无消息时展示 -->
          <div class="no-news" v-else v-loading="collectLoading">暂无内容</div>
          <!-- 分页 -->
          <div style="margin-top: 20px; float: right" v-if="collectMessageList.length > 0">
            <el-pagination
              :page-sizes="g_pageSizesConfig"
              @size-change="handleCollectSizeChange"
              @current-change="handleCollectCurrentChange"
              :current-page="collectPageIndex"
              :page-size="collectPageSize"
              layout="total,sizes, prev, pager, next, jumper"
              :total="collectTotal"
            ></el-pagination>
          </div>
          <!-- 视频放大 -->
          <el-dialog :visible.sync="repVideoDialogVisible" width="50%" @close="handleClose">
            <div style="display: flex; justify-content: center; align-items: center">
              <Mvideo width="800" height="400" name="2" :src="collectVideoSrc"></Mvideo>
            </div>
          </el-dialog>
          <!-- 图片放大 -->
          <el-dialog :visible.sync="repImgDialogVisible" width="30%">
            <div style="display: flex; justify-content: center; align-items: center">
              <img width="420" height="590" :src="collectImgSrc" />
            </div>
          </el-dialog>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Maudio from '@/components/audio/audio.vue';
import Mvideo from '@/components/video/index.vue';
import { mapActions } from 'vuex';
import Maps from '@/views/messageManagement/messageList/components/maps.vue';
import {
  GetAppMsgList,
  ReplyMsg,
  CollectMsg,
  GetCollectMsgList,
  QuerNewMsgNum,
  ExportMessage,
} from '@/api/messageManagement.js';
import { parseTime } from '@/utils/time.js';
export default {
  name: 'MessageList',
  components: {
    Maudio,
    Mvideo,
    Maps,
  },
  data() {
    return {
      date: 0,
      msgVideoDialogVisible: false,
      msgImgDialogVisible: false,
      msgVideoSrc: '',
      msgImgSrc: '',

      repVideoDialogVisible: false,
      repImgDialogVisible: false,
      collectVideoSrc: '',
      collectImgSrc: '',

      name: 'first', // 当前页面名字
      content: '',
      collectContent: '',
      collect:
        'https://baike-med-1256891581.file.myqcloud.com/2021041/067aa120-a18e-11eb-ae0e-21d0e54b35ac_0.png',
      noCollect:
        'https://baike-med-1256891581.file.myqcloud.com/2021045/0812f460-a18e-11eb-87f5-87f8260230cc_0.png',
      loading: false,
      collectLoading: false,
      listLoading: false,
      collectListLoading: false,
      AppId: '',
      collectAppId: '',
      page_size: this.g_pageSizeDefault,
      page_index: 1,
      total: 0,
      messageList: [], // 消息列表数据
      collectMessageList: [], // 收藏消息列表
      collectPageSize: this.g_pageSizeDefault,
      collectPageIndex: 1,
      collectTotal: 0,
      timer: null,
      avatarDefault:
        'https://baike-med-1256891581.file.myqcloud.com/2021124/c57df790-5d70-11ec-a3f4-354087f4d05d_0.png',
    };
  },
  computed: {
    AppIdsOptions() {
      // 公众号列表
      return this.$store.getters['user/getPublishList'];
    },
  },
  async created() {
    this.page_size = this.g_pageSizeDefault;
    this.collectPageSize = this.g_pageSizeDefault;
    await this.getManagerLogin();
    this.date = +new Date();
    this.handleSelectAppId();
    this.handleCollectAppId();
    this.timer = setInterval(() => {
      QuerNewMsgNum({ old_time: this.date, t_now: +new Date() }).then((res) => {
        for (const item of Object.values(res.res)) {
          if (item > 0) {
            this.$notify({
              type: 'info',
              title: '消息通知',
              dangerouslyUseHTMLString: true,
              message: '有新的消息请点击查看',
              onClick: () => {
                this.$router.go(0);
              },
            });
          }
        }
      });
    }, 10000);
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    parseTime,
    handleJumpBehalf(val) {
      // 跳转代表
      this.g_tourl(`/saas/representDetaill.html?id=${val}&type=newWindow`, { open: true });
    },
    handleClose() {
      const { videoList } = window;
      for (const [key, video] of videoList) {
        if (key !== this.name) {
          video.pause();
        }
      }
    },
    handleDetailVideo(val) {
      this.msgVideoDialogVisible = true;
      this.msgVideoSrc = val.media_url;
    },
    handleDetailImg(val) {
      this.msgImgDialogVisible = true;
      this.msgImgSrc = val.media_url;
    },
    handleDetailCollectVideo(val) {
      this.repVideoDialogVisible = true;
      this.collectVideoSrc = val.media_url;
    },
    handleDetailCollectImg(val) {
      this.repImgDialogVisible = true;
      this.collectImgSrc = val.media_url;
    },

    handlePackUp(item) {
      if (this.name === 'first') {
        item.inputShow = false;
        this.content = '';
      } else if (this.name === 'second') {
        item.inputShow = false;
        this.collectContent = '';
      }
    },
    handleClickChange(tab) {
      // 获取当前页面名字
      this.name = tab.name;
      this.date = +new Date();
      if (this.name === 'first') {
        this.handleCurrentChange(this.page_index);
      } else if (this.name === 'second') {
        this.handleCollectCurrentChange(this.collectPageIndex);
      }
    },
    handleCollectCurrentChange(val) {
      // 收藏消息页翻页
      this.collectPageIndex = val;
      if (this.collectAppId === '') {
        this.handleCollectAppId();
      } else {
        this.handleCollectAppId(this.collectAppId);
      }
    },
    handleCurrentChange(val) {
      // 总消息页翻页
      this.page_index = val;
      if (this.AppId === '') {
        this.handleSelectAppId();
      } else {
        this.handleSelectAppId(this.AppId);
      }
    },
    handleCollectSizeChange(val) {
      this.collectPageSize = val;
      if (this.collectAppId === '') {
        this.handleCollectAppId();
      } else {
        this.handleCollectAppId(this.collectAppId);
      }
    },
    handleSizeChange(val) {
      this.page_size = val;
      if (this.AppId === '') {
        this.handleSelectAppId();
      } else {
        this.handleSelectAppId(this.AppId);
      }
    },
    handleUserDetail(val) {
      // 跳转用户详细
      this.g_tourl(`/saas/userMessageList.html?app_id=${val.app_id}&open_id=${val.open_id}`);
    },
    handleCollect(val) {
      // 收藏与取消收藏
      if (this.name === 'first') {
        if (val.is_collect === 1) {
          CollectMsg({ msg_id: val.msg_id })
            .then(() => {
              if (this.AppId === '') {
                this.handleSelectAppId();
              } else {
                this.handleSelectAppId(this.AppId);
              }
              if (this.collectMessageList.length > 0 || this.AppId === this.collectAppId) {
                if (this.collectAppId === '') {
                  this.handleCollectAppId();
                } else {
                  this.handleCollectAppId(this.collectAppId);
                }
              }
              this.$message.success('取消收藏成功');
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        } else if (val.is_collect === 2) {
          CollectMsg({ msg_id: val.msg_id })
            .then(() => {
              if (this.AppId === '') {
                this.handleSelectAppId();
              } else {
                this.handleSelectAppId(this.AppId);
              }
              if (this.collectMessageList.length > 0 || this.AppId === this.collectAppId) {
                if (this.collectAppId === '') {
                  this.handleCollectAppId();
                } else {
                  this.handleCollectAppId(this.collectAppId);
                }
              }
              this.$message.success('收藏成功');
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        }
      } else if (this.name === 'second') {
        CollectMsg({ msg_id: val.msg_id })
          .then(() => {
            if (this.collectAppId === '') {
              this.handleCollectAppId();
            } else {
              this.handleCollectAppId(this.collectAppId);
            }
            if (this.messageList.length > 0 || this.AppId === this.collectAppId) {
              if (this.AppId === '') {
                this.handleSelectAppId();
              } else {
                this.handleSelectAppId(this.AppId);
              }
            }
            this.$message.success('取消收藏成功');
          })
          .catch((err) => {
            this.$message.error(err.message);
          });
      }
    },
    sendMessage(val) {
      // 回复消息
      if (this.name === 'first') {
        if (this.content === '') {
          this.$message.error('发送失败，请输入内容');
          return;
        }
        const date = +new Date();
        const req = {
          msg_id: val.msg_id,
          content: this.content,
        };
        if (date - val.create_time > 172800000) {
          this.content = '';
          this.$message.error('该用户已经超过48小时未与你互动，无法回复');
          return false;
        }
        ReplyMsg(req)
          .then(() => {
            if (this.AppId === '') {
              this.handleSelectAppId();
            } else {
              this.handleSelectAppId(this.AppId);
            }
            if (this.collectMessageList.length > 0 || this.AppId === this.collectAppId) {
              if (this.collectAppId === '') {
                this.handleCollectAppId();
              } else {
                this.handleCollectAppId(this.collectAppId);
              }
            }
            this.content = '';
            this.$message.success('回复成功');
          })
          .catch((err) => {
            this.$message.error(err.message);
          });
      } else if (this.name === 'second') {
        if (this.collectContent === '') {
          this.$message.error('发送失败，请输入内容');
          return;
        }
        const date = +new Date();
        const req = {
          msg_id: val.msg_id,
          content: this.collectContent,
        };
        if (date - val.create_time > 172800000) {
          this.collectContent = '';
          this.$message.error('该用户已经超过48小时未与你互动，无法回复');
          return false;
        }
        ReplyMsg(req)
          .then(() => {
            if (this.collectAppId === '') {
              this.handleCollectAppId();
            } else {
              this.handleCollectAppId(this.collectAppId);
            }
            if (this.messageList.length > 0 || this.AppId === this.collectAppId) {
              if (this.AppId === '') {
                this.handleSelectAppId();
              } else {
                this.handleSelectAppId(this.AppId);
              }
            }
            this.collectContent = '';
            this.$message.success('回复成功');
          })
          .catch((err) => {
            this.$message.error(err.message);
          });
      }
    },
    handleShowInput(val) {
      // 点击展示输入框
      if (this.name === 'first') {
        this.content = '';
        this.messageList.forEach((item) => {
          if (item.msg_id === val.msg_id) {
            item.inputShow = true;
          } else {
            item.inputShow = false;
          }
        });
      } else if (this.name === 'second') {
        this.collectContent = '';
        this.collectMessageList.forEach((item) => {
          if (item.msg_id === val.msg_id) {
            item.inputShow = true;
          } else {
            item.inputShow = false;
          }
        });
      }
    },
    ...mapActions('user', ['getManagerLogin']),
    handleChangeGetList() {
      this.date = +new Date();
      this.page_index = 1;
      if (this.AppId === '') {
        this.handleSelectAppId();
      } else {
        this.handleSelectAppId(this.AppId);
      }
    },
    handleSelectAppId(val = 'all') {
      // 查询消息列表数据
      this.loading = true;
      this.listLoading = true;
      const req = {
        app_id: val,
        time_limit: this.date,
        page_size: this.page_size,
        page_index: this.page_index,
      };
      GetAppMsgList(req)
        .then((res) => {
          const arr = res.msgs;
          this.total = res.total;
          this.messageList = arr.map((item) => {
            return { ...item, inputShow: false };
          });
          this.loading = false;
          this.listLoading = false;
        })
        .catch((err) => {
          this.$message.error(err.message);
          this.loading = false;
          this.listLoading = false;
          this.messageList = [];
        });
    },
    exportMessage() {
      // 导出消息列表
      if (!this.AppId) {
        this.$message.warning('请选择一个公众号');
        return;
      }
      ExportMessage({
        app_id: this.AppId,
        time_limit: this.date,
        page_size: 99999,
        page_index: 1,
      })
        .then(({ content }) => {
          this.g_tourl(content, { open: true });
        })
        .catch((e) => this.$message.error(e));
    },
    handleChangeCollectGetList() {
      this.date = +new Date();
      this.collectPageIndex = 1;
      if (this.collectAppId === '') {
        this.handleCollectAppId();
      } else {
        this.handleCollectAppId(this.collectAppId);
      }
    },
    handleCollectAppId(val = 'all') {
      // 查询收藏列表数据
      this.collectLoading = true;
      this.collectListLoading = true;
      GetCollectMsgList({
        app_id: val,
        time_limit: this.date,
        page_size: this.collectPageSize,
        page_index: this.collectPageIndex,
      })
        .then((res) => {
          // console.log(res);
          this.collectMessageList = res.msgs;
          this.collectTotal = res.total;
          this.collectMessageList = this.collectMessageList.map((item) => {
            return { ...item, inputShow: false };
          });
          this.collectLoading = false;
          this.collectListLoading = false;
        })
        .catch((err) => {
          this.$message.error(err.message);
          this.collectLoading = false;
          this.collectListLoading = false;
          this.collectMessageList = [];
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.header-select {
  height: 70px;
  border-bottom: 1px solid #edeff2;
  margin-top: 22px;
}
.content {
  box-sizing: border-box;
  padding: 20px 20px;
  border-bottom: 1px solid #edeff2;
  .message-list {
    display: flex;
    justify-content: space-between;
    .head-portrait {
      cursor: pointer;
      width: 48px;
      height: 48px;
    }
    .message-data {
      min-height: 80px;
      // max-width: 280px;
      // min-width: 200px;
      width: 25%;
      div:first-child {
        font-size: 14px;
        color: #626366;
        line-height: 22px;
        margin-bottom: 10px;
        .reply-tag {
          display: inline-block;
          width: 56px;
          height: 22px;
          background: #edeff2;
          font-size: 12px;
          color: #939599;
          text-align: center;
          line-height: 20px;
        }
      }
      div:nth-child(2) {
        word-wrap: break-word;
        // width: 160px;
        // max-height: 100px;
        font-size: 14px;
        color: #313233;
        line-height: 22px;
        margin-bottom: 10px;
        cursor: pointer;
        a {
          display: inline-block;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      div:last-child {
        font-size: 12px;
        color: #939599;
        line-height: 22px;
        margin-bottom: 20px;
      }
    }
    div:nth-child(3) {
      min-width: 80px;
      font-size: 14px;
      color: #626366;
      letter-spacing: 0;
      line-height: 22px;
    }
    div:nth-child(4) {
      min-width: 100px;
      max-width: 112px;
      font-size: 14px;
      color: #626366;
      letter-spacing: 0;
      line-height: 22px;
    }
    div:nth-child(5) {
      min-width: 100px;
      font-size: 14px;
      color: #626366;
      letter-spacing: 0;
      line-height: 22px;
    }
    div:nth-child(6) {
      min-width: 100px;
      font-size: 14px;
      color: #626366;
      letter-spacing: 0;
      line-height: 22px;
    }
    div:nth-child(7) {
      min-width: 100px;
      font-size: 14px;
      color: #626366;
      letter-spacing: 0;
      line-height: 22px;
    }
    div:nth-child(8) {
      min-width: 80px;
      font-size: 14px;
      color: #2f96ff;
      letter-spacing: 0;
      line-height: 22px;
    }
    div:nth-child(9) {
      display: flex;
      img {
        width: 22px;
        height: 22px;
        cursor: pointer;
      }
      span {
        font-size: 24px;
        margin-left: 25px;
        cursor: pointer;
        color: rgb(191, 191, 191);
      }
    }
  }
}
.send-content {
  .el-textarea {
    height: 160px;
    ::v-deep.el-textarea__inner {
      resize: none;
      height: 160px;
    }
  }
}
.send-button {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
}
.no-news {
  width: 100%;
  height: 500px;
  text-align: center;
  line-height: 500px;
  font-size: 32px;
  color: #909399;
}
.img-dialog {
  padding: 0;
  ::v-deep.el-dialog__header,
  ::v-deep.el-dialog__body {
    padding: 0;
  }

  ::v-deep.el-dialog {
    padding: 0;
  }
}
</style>
